// Phase 3 — Angular HttpClient port of the AngularJS `secretKeyInteceptor`
// (inteceptors/keyInteceptor.js). The server requires a `secret-key` md5 header on every
// request; HttpClient bypasses the AngularJS $http interceptor chain, so we re-add it here.
//
// The hash is computed with the SAME AngularJS `md5` service (upgraded into Angular via the
// NG1_MD5 token in ng/upgrades.ts), guaranteeing identical output to the legacy interceptor.
import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NG1_MD5 } from '../upgrades';

export const secretKeyInterceptor: HttpInterceptorFn = (req, next) => {
    const md5 = inject(NG1_MD5);
    const hash = md5.createHash(Math.round(Date.now() / 1000000) + 'TheAppSecret');
    return next(req.clone({ setHeaders: { 'secret-key': hash } }));
};
